// import React, { useState } from 'react';
// import { baseURL } from '../apiConfig'; // <-- Apni nayi central file se baseURL import kiya

// import './SalesRegister.css';

// function SalesRegister() {
//   // 📅 Dynamic Dates Logic (Aapka Exact Original Logic)
//   // const baseURL = process.env.REACT_APP_API_URL || 'http://10.179.18.97:8000';
//   const getDynamicDates = () => {
//     const today = new Date();
//     const yyyy = today.getFullYear();
//     const mm = String(today.getMonth() + 1).padStart(2, '0'); 
//     const dd = String(today.getDate()).padStart(2, '0');
    
//     const currentDateStr = `${yyyy}-${mm}-${dd}`;
//     const firstDateStr = `${yyyy}-${mm}-01`; 

//     return { firstDateStr, currentDateStr };
//   };

//   const { firstDateStr, currentDateStr } = getDynamicDates();

//   const [fromDate, setFromDate] = useState(firstDateStr); 
//   const [toDate, setToDate] = useState(currentDateStr);
//   const [reportData, setReportData] = useState([]);
//   const [showReport, setShowReport] = useState(false);

//   // 🔍 Fetch Data from Backend (.env Dynamic IP Connection Ke Sath)
//   const handleShowReport = async () => {
//     try {
//       // .env file se REACT_APP_API_URL uthayega, agar nahi mila toh fallback pe aapka IP chalega
//       // const baseURL = process.env.REACT_APP_API_URL || 'http://10.179.18.97:8000';
      
//       const response = await fetch(`${baseURL}/api/sales-register/?from=${fromDate}&to=${toDate}`);
//       if (!response.ok) {
//         throw new Error(`Server responded with status: ${response.status}`);
//       }
//       const result = await response.json();
//       if (result.success === true) {
//         if (result.data.length === 0) {
//           alert("Is selected date range me koi sales records nahi mile!");
//         }
//         setReportData(result.data); 
//         setShowReport(true);
//       } else {
//         alert("Backend issue: " + result.message);
//       }
//     } catch (err) {
//       console.error("Fetch error:", err);
//       alert("Database connection check karein backend band hai shayad!");
//     }
//   };

//   // 📄 Action Button Handler (.env Dynamic IP Connection)
//   const handleViewPdf = (invoiceNo) => {
//     if (!invoiceNo) {
//       alert("Invoice number missing!");
//       return;
//     }
    
//     // const baseURL = process.env.REACT_APP_API_URL || 'http://10.179.18.97:8000';
//     const pdfUrl = `${baseURL}/api/sales/view-pdf/${invoiceNo}/`;
//     window.open(pdfUrl, '_blank');
//   };

//   const handlePrint = () => {
//     window.print();
//   };

//   return (
//     <div className="register-container">
//       {/* Search Header Panel */}
//       {/* <div className="filter-card"> */}
//       <div className="filter-card no-print">
//         <div className="filter-row">
//           <div className="date-input-group">
//             <label>From Date</label>
//             <input 
//               type="date" 
//               value={fromDate}
//               onChange={(e) => setFromDate(e.target.value)} 
//             />
//           </div>

//           <div className="date-input-group">
//             <label>To Date</label>
//             <input 
//               type="date" 
//               value={toDate}
//               onChange={(e) => setToDate(e.target.value)} 
//             />
//           </div>

//           <button className="btn-show" onClick={handleShowReport}>
//             Show Report
//           </button>
//         </div>
//       </div>

//       {/* 📄 Printable Report Area */}
//       {showReport && (
//         <div className="report-paper-view">
//           <div className="print-actions no-print">
//             <button className="btn-print" onClick={handlePrint}>🖨️ Print / Save as PDF</button>
//           </div>

//           {/* YOUR EXACT ORIGINAL CLASS FOR WHITE SHEET BOX */}
//           <div className="a4-print-sheet">
//             {/* Header */}
//             <div className="report-header">
//               <div className="logo-placeholder">TJ</div>
//               <div className="company-details">
//                 <h1>TIYA JEWELLERS</h1>
//                 <p>Mahadev Tower, Dr. R P Lane Road</p>
//                 <p>Bhagalpur, Bihar - 812001</p>
//               </div>
//               <div className="report-meta">
//                 <h3>Sales Register</h3>
//                 <p>Pages: 1 / 1</p>
//               </div>
//             </div>

//             {/* YOUR EXACT ORIGINAL TABLE CLASS */}
//             <table className="sales-register-table">
//               <thead>
//                 <tr>
//                   <th>Sl no.</th>
//                   <th>Invoice No.<br/>Date</th>
//                   <th>Customer<br/>Name, Address, Mob.</th>
//                   <th>Tag ID<br/>item Name</th>
//                   <th>Weight<br/>Rate & Purity</th>
//                   <th>Making<br/>Discount<br/>Pre Total</th>
//                   <th>CGST<br/>SGST<br/>Sub Total</th>
//                   <th>Payment mode<br/>Bill Total</th>
//                   <th>Remarks &<br/>Sold By</th>
//                   <th className="no-print">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {reportData.map((item, idx) => (
//                   <tr key={idx}>
//                     <td>{idx + 1}</td>
//                     <td><strong>{item.invoice}</strong><br/>{item.date}</td>
//                     <td><strong>{item.name}</strong><br/>{item.address}<br/>{item.mobile}</td>
//                     <td>{item.tagId}<br/><strong>{item.itemName}</strong></td>
//                     <td>{item.weight}<br/>{item.rate}<br/>{item.purity}</td>
//                     <td>{item.making}<br/>{item.discount}<br/>{item.preTotal}</td>
//                     <td>{item.cgst}<br/>{item.sgst}<br/><strong>{item.subTotal}</strong></td>
//                     <td>{item.payMode}<br/><strong>{item.billTotal}</strong></td>
//                     <td><br/>{item.soldBy}</td>
//                     <td className="no-print" style={{ textAlign: 'center' }}>
//                       <button 
//                         onClick={() => handleViewPdf(item.invoice)} 
//                         style={{ cursor: 'pointer', background: 'none', border: 'none', fontSize: '18px' }}
//                         title="Print / View Invoice PDF"
//                       >
//                         🖨️
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default SalesRegister;

import React, { useState } from 'react';
import { baseURL } from '../apiConfig';
import './SalesRegister.css';

function SalesRegister() {
  const getDynamicDates = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); 
    const dd = String(today.getDate()).padStart(2, '0');
    
    const currentDateStr = `${yyyy}-${mm}-${dd}`;
    const firstDateStr = `${yyyy}-${mm}-01`; 

    return { firstDateStr, currentDateStr };
  };

  const { firstDateStr, currentDateStr } = getDynamicDates();

  const [fromDate, setFromDate] = useState(firstDateStr); 
  const [toDate, setToDate] = useState(currentDateStr);
  const [billType, setBillType] = useState('Regular'); // 👈 Naya Bill Type State
  const [reportData, setReportData] = useState([]);
  const [showReport, setShowReport] = useState(false);

  // 🔍 Fetch Data with Bill Type
  const handleShowReport = async () => {
    try {
      // API call me type parameter pass kiya
      const response = await fetch(`${baseURL}/api/sales-register/?from=${fromDate}&to=${toDate}&type=${billType}`);
      if (!response.ok) {
        throw new Error(`Server responded with status: ${response.status}`);
      }
      const result = await response.json();
      if (result.success === true) {
        if (result.data.length === 0) {
          alert(`Selected date range me koi ${billType} sales records nahi mile!`);
        }
        setReportData(result.data); 
        setShowReport(true);
      } else {
        alert("Backend issue: " + result.message);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      alert("Database connection check karein backend band hai shayad!");
    }
  };

  // const handleViewPdf = (invoiceNo) => {
  //   if (!invoiceNo) {
  //     alert("Invoice number missing!");
  //     return;
  //   }
  //   const pdfUrl = `${baseURL}/api/sales/view-pdf/${invoiceNo}/`;
  //   window.open(pdfUrl, '_blank');
  // };

  // const handlePrint = () => {
  //   window.print();
  // };

  const handleViewPdf = async (invoiceNo) => {
    if (!invoiceNo) {
      alert("Invoice number missing!");
      return;
    }

    try {
      // Backend se PDF mangwana (billType bhi bhej rahe hain taaki backend sahi bill dhundh sake)
      const response = await fetch(`${baseURL}/api/sales/view-pdf/${invoiceNo}/?type=${billType}`);

      if (!response.ok) {
        throw new Error("Bill fetch karne me dikkat aayi");
      }

      // PDF ko blob me convert karna
      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);

      // File ka naam dynamic set karna (Estimated hai ya Regular)
      const prefix = billType === 'Estimated' ? 'E' : 'R';
      const fileName = `${prefix}_Invoice_${invoiceNo}.pdf`;

      // 1. Background me download trigger karna
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.setAttribute('download', fileName); 
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

      // 2. Naye tab me preview ke liye kholna
      window.open(pdfUrl, '_blank');

      // 3. Memory clean up
      setTimeout(() => {
          window.URL.revokeObjectURL(pdfUrl);
      }, 2000);

    } catch (error) {
      console.error("PDF load error:", error);
      alert("PDF load nahi ho paya. Backend connection check karein.");
    }
  };
  const handlePrint = () => {
    window.print();
  };
  return (
    <div className="register-container">
      <div className="filter-card no-print">
        <div className="filter-row">
          <div className="date-input-group">
            <label>From Date</label>
            <input 
              type="date" 
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)} 
            />
          </div>

          <div className="date-input-group">
            <label>To Date</label>
            <input 
              type="date" 
              value={toDate}
              onChange={(e) => setToDate(e.target.value)} 
            />
          </div>

          {/* 🟢 NAYA BILL TYPE DROPDOWN */}
          <div className="date-input-group">
            <label>Bill Type</label>
            <select 
              value={billType} 
              onChange={(e) => setBillType(e.target.value)}
              style={{
                padding: '8px',                
                borderRadius: '4px',
                border: '1px solid #555',
                fontWeight: 'bold',
                background: '#333', 
                color: '#fff'                 
              }}
            >
              <option value="Regular">Regular</option>
              <option value="Estimated">Estimated</option>
            </select>
          </div>

          <button className="btn-show" onClick={handleShowReport}>
            Show Report
          </button>
        </div>
      </div>

      {showReport && (
        <div className="report-paper-view">
          <div className="print-actions no-print">
            <button className="btn-print" onClick={handlePrint}>🖨️ Print / Save as PDF</button>
          </div>

          <div className="a4-print-sheet">
            <div className="report-header">
              <div className="logo-placeholder">TJ</div>
              <div className="company-details">
                <h1>TIYA JEWELLERS</h1>
                <p>Mahadev Tower, Dr. R P Lane Road</p>
                <p>Bhagalpur, Bihar - 812001</p>
              </div>
              <div className="report-meta">
                <h3>{billType === 'Estimated' ? 'Estimated Sales Register' : 'Sales Register'}</h3>
                <p>Pages: 1 / 1</p>
              </div>
            </div>

            <table className="sales-register-table">
              <thead>
                <tr>
                  <th>Sl no.</th>
                  <th>Invoice No.<br/>Date</th>
                  <th>Customer<br/>Name, Address, Mob.</th>
                  <th>Tag ID<br/>item Name</th>
                  <th>Weight<br/>Rate & Purity</th>
                  <th>Making<br/>Discount<br/>Pre Total</th>
                  <th>CGST<br/>SGST<br/>Sub Total</th>
                  <th>Payment mode<br/>Bill Total</th>
                  <th>Remarks &<br/>Sold By</th>
                  <th className="no-print">Action</th>
                </tr>
              </thead>
              <tbody>
                {reportData.map((item, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td><strong>{item.invoice}</strong><br/>{item.date}</td>
                    <td><strong>{item.name}</strong><br/>{item.address}<br/>{item.mobile}</td>
                    <td>{item.tagId}<br/><strong>{item.itemName}</strong></td>
                    <td>{item.weight}<br/>{item.rate}<br/>{item.purity}</td>
                    <td>{item.making}<br/>{item.discount}<br/>{item.preTotal}</td>
                    <td>{item.cgst}<br/>{item.sgst}<br/><strong>{item.subTotal}</strong></td>
                    <td>{item.payMode}<br/><strong>{item.billTotal}</strong></td>
                    <td><br/>{item.soldBy}</td>
                    <td className="no-print" style={{ textAlign: 'center' }}>
                      <button 
                        onClick={() => handleViewPdf(item.invoice)} 
                        style={{ cursor: 'pointer', background: 'none', border: 'none', fontSize: '18px' }}
                        title="Print / View Invoice PDF"
                      >
                        🖨️
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default SalesRegister;